export class ObjectServiceLogModel {
  Id: number;
  ObjectId: number;
  Date: number = new Date().getTime();
  Value: string;

  constructor(data?: any) {
    this.init(data);
  }

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.ObjectId = data["objectId"];
      this.Date = data["date"] ?? new Date().getTime();
      this.Value = data["value"];
    }
  }

  static fromJS(data: any): ObjectServiceLogModel {
    data = typeof data === 'object' ? data : {};
    return new ObjectServiceLogModel(data);
  }
}
